import React, { Component } from "react";
import { Container } from "reactstrap";
import {
  successNotification,
  errorNotification
} from "../../../../utils/notifications";
import { ConfiguracionContactCenterDispatcher } from "../../../containers/comisionesMembresiaConfiguracion/configuracionContactCenter/ConfiguracionContactCenter.dispatcher";
import { ConfiguracionContactCenterStore } from "../../../containers/comisionesMembresiaConfiguracion/configuracionContactCenter/ConfiguracionContactCenter.store";
import FormBuilder from "../../../../toolkit/baseForms2/formBuilder/FormBuilder";
import { formConfig, Inputs, Buttons } from "./ConfiguracionContactCenter.form";
import { ConfiguracionContactCenterTable } from "./ConfiguracionContactCenter.table";
import ISelectBuilder from "../../../../toolkit/baseForms2/iSelectBuilder/ISelectBuilder";

interface Props
  extends ConfiguracionContactCenterStore,
    ConfiguracionContactCenterDispatcher {}

interface State {
  mes: String;
  anio: number;
  supervisor: String;
  metaSupervisor: number;
  metaOperador: number;
  operadoresSelected: number[];
}

export default class ConfiguracionContactCenterComponent extends Component<
  Props,
  State
> {
  state: State = {
    mes: "",
    anio: 0,
    supervisor: "",
    metaSupervisor: 0,
    metaOperador: 0,
    operadoresSelected: []
  };

  componentDidMount() {
    this.loadSupervisor();
    this.loadOperador();
  }

  loadSupervisor = async () => {
    const previewSupervisor = await this.props.getSupervisorContactCenter();

    if (previewSupervisor.fulfilled) {
      successNotification("Supervisores cargados correctamente");
    } else {
      errorNotification(previewSupervisor.gettingSupervisorContactCenterError);
    }
  };

  loadOperador = async () => {
    const previewOperador = await this.props.getOperadorContactCenter();

    if (previewOperador.fulfilled) {
      successNotification("Operadores cargados correctamente");
    } else {
      errorNotification(previewOperador.gettingOperadorContactCenterError);
    }
  };

  handleSubmit = async (values: any) => {
    const { mes, anio, supervisor, metaSupervisor, metaOperador } = values;
    const { operadoresSelected } = this.state;

    if (!mes || !anio || !supervisor || !metaSupervisor || !metaOperador) {
      errorNotification("Por favor complete todos los campos requeridos");
      return;
    }

    const data = {
      mes: parseInt(mes),
      anio: parseInt(anio),
      idSupervisor: parseInt(supervisor),
      metaSupervisor: parseFloat(metaSupervisor),
      metaOperador: parseFloat(metaOperador),
      operadoresSelected: operadoresSelected || []
    };

    const previewPost = await this.props.postContactCenter(data);

    if (previewPost.fulfilled) {
      successNotification("Configuración guardada correctamente");
      this.setState({ operadoresSelected: [] });
    } else {
      errorNotification(previewPost.postingContactCenterError);
    }
  };

  handleSelectionChange = (selected: number[]) => {
    this.setState({ operadoresSelected: selected });
  };

  onChange = (_values: any) => {
    // Placeholder para onChange
  };

  render() {
    const { operadorContactCenter, supervisorContactCenter } = this.props;
    const listOpe = operadorContactCenter;

    // const lisSup = supervisorContactCenter;

    // const { operadores, supervisores } = this.props;
    // const { mes, anio, supervisor, metaSupervisor, metaOperador, operadoresSelected } = this.state;

    return (
      <>
        <Container>
          <FormBuilder<Inputs, Buttons>
            config={formConfig}
            submit={this.handleSubmit}
            onChange={this.onChange}
          >
            <ISelectBuilder
              name="supervisor"
              data={supervisorContactCenter}
              mapOption={s => ({
                label: `(${s.numeroEmpleado}) ${s.nombre}`,
                value: s.id
              })}
            />
          </FormBuilder>
          <ConfiguracionContactCenterTable
            data={listOpe}
            onSelectionChange={this.handleSelectionChange}
          />
        </Container>
        {/* <div className="container">
            <div className="mt-4">
                
            </div>
        </div> */}
      </>
    );
  }
}
